module.exports = "../../../../platform/assets/pageMainIcon/icon-shuzhi-3-red.svg";